export enum ManualOverrideSettingKey {
  SEARCH_EXPERIMENT_OVERRIDE = 'SEARCH_EXPERIMENT_OVERRIDE',
  BETA_ENVIRONMENT = 'BETA_ENVIRONMENT',
  NEW_SEARCH_PANEL_ENABLED = 'NEW_SEARCH_PANEL_ENABLED',
}
